/**
 * Actions on the UM dashboard
 */
export const UmDashboardActionTypes = {
    UPDATE_UM_DASHBOARD_DATA_ALL_USERS: 'UPDATE_UM_DASHBOARD_DATA_ALL_USERS',
    UPDATE_UM_DASHBOARD_DATA_ALL_USER_REQUESTS: 'UPDATE_UM_DASHBOARD_DATA_ALL_USER_REQUESTS',
    UPDATE_UM_DASHBOARD_FILTER_PLATFORM: 'UPDATE_UM_DASHBOARD_FILTER_PLATFORM',
    UPDATE_UM_DASHBOARD_FILTER_ROLE: 'UPDATE_UM_DASHBOARD_FILTER_ROLE',
    UPDATE_UM_DASHBOARD_FILTER_PERMISSIONS: 'UPDATE_UM_DASHBOARD_FILTER_PERMISSIONS',
    UPDATE_UM_DASHBOARD_FILTER_LOCALE: 'UPDATE_UM_DASHBOARD_FILTER_LOCALE',
    UPDATE_UM_DASHBOARD_SORT_DESCRIPTOR: 'UPDATE_UM_DASHBOARD_SORT_DESCRIPTOR',
    UPDATE_UM_DASHBOARD_SEARCH_STR: 'UPDATE_UM_DASHBOARD_SEARCH_STR',
    UPDATE_UM_DASHBOARD_SEARCH_FROM: 'UPDATE_SEARCH_FROM_UM',
    UPDATE_UM_DASHBOARD_SEARCH_SIZE: 'UPDATE_SEARCH_SIZE_UM',
    UPDATE_UM_DASHBOARD_RESET_ALL_FILTERS: 'RESET_ALL_FILTERS_UM',
};

/**
 * Actions on the UM step form
 */
export const UmStepFormActionTypes = {
    UPDATE_UM_STEP_FORM_: 'UPDATE_ROLE_UM',
    UPDATE_UM_DASHBOARD_FILTER_PLATFORM: 'UPDATE_STATUS_UM',
    UPDATE_UM_DASHBOARD_FILTER_PERMISSIONS: 'UPDATE_TOOL_UM',
    UPDATE_UM_DASHBOARD_FILTER_LOCALE: 'UPDATE_PERMISSION_UM',
    UPDATE_LOCALE_UM: 'UPDATE_LOCALE_UM',
};
